<template>
  <div class="content-gallery-overlay">
    <slot name="close"></slot>
    <div class="gallery-content">
      <iframe
        v-if="!!frameSrc && !!contentReady"
        :class="[att.type === 'issue' ? 'fullh' : '']"
        ref="frame"
        :src="frameSrc"
        frameborder="0"
      ></iframe>
      <preloader v-if="!contentReady"></preloader>
    </div>
  </div>
</template>
<script>
export default {
  props: ["id", "attachments", "title", "desc", "image", "activeIndex"],
  data() {
    return {
      minimized: true,
      activeSocial: false,
      contentReady: false
    };
  },
  mounted() {
    setTimeout(
      function() {
        this.minimized = false;
        setTimeout(
          function() {
            this.contentReady = true;
          }.bind(this),
          1300
        );
      }.bind(this),
      300
    );
  },
  methods: {
    toggleBar() {
      this.minimized = !this.minimized;
    },
    toggleSocial() {
      this.$set(this, "activeSocial", !this.activeSocial);
    }
  },
  computed: {
    currentLocation() {
      return window.location.href + "/";
    },
    totalItems() {
      return this.attachments.length;
    },
    noZeroIndex() {
      return this.activeIndex + 1;
    },
    formattedDesc() {
      let _desc = this.desc.replace("<br/>", " ");
      console.log("_desc >> ", _desc);
      return _desc;
    },
    downloadSrc() {
      let at = this.attachments[this.activeIndex];
      return at.download || null;
    },
    frameSrc() {
      let at = this.att;
      return at.type === "issue"
        ? `https://www.mis-implants.com/windows/winIssuu.aspx?CID=${this.id}`
        : at.type === "video"
        ? `https://www.youtube.com/embed/${at.link}?rel=0`
        : null;
    },
    att() {
      return this.attachments[this.activeIndex];
    }
  }
};
</script>
<style lang="stylus">
darker = #353535
light = #6d6e6f
lighter = #bebebe
blue = #66d8fb

.fadeup-item
  display inline-block
  margin-right 10px

.content-gallery-overlay
	position fixed
	width 100%
	height 100%
	left 0
	top 0
	z-index 999
	overflow hidden
	background #fff
	.closebtn
		z-index 999
		top 10px
		right 10px
		position absolute
.gallery-under-bar
	width 100%
	position absolute
	top 5vh
	left 5vw
	transform translate(0, -50%)
	z-index 2
	& > div
		display inline-block
	.small-round
		width 38px
		height @width
		border-radius unit(@width/2, 'px')
		background #727272
		display inline-block
		vertical-align middle
		margin-right 8px
		position relative
		transition background 0.3s ease
		opacity 1
		cursor pointer

		i
			self-center()
			color darker
			font-size 18px
			transition color 0.3s ease
			&.icon-download
				font-size 12px
		&:hover, &.active
			background #fff
		&.social
			background #dddddd
			&:nth-child(1)
				transition all 0.4s ease
			&:nth-child(2)
				transition all 0.5s ease
			&:nth-child(3)
				transition all 0.6s ease

			&:hover
				background #05a5e6
				i
					color #fff



.gallery-content
	width 100%
	height 100%
	position relative
	iframe
		center()
		width 90%
		height 90%
		transform translate(-50%,-50%)
		&.fullh
			height 100%
</style>
